import React, { ReactNode } from 'react';
import { useDisclaimerModal } from '../../hooks/useDisclaimerModal';

type Props = {
    children: ReactNode;
};

/**
 * Wrapper component that triggers the disclaimer modal on app load.
 * Must be placed inside ModalState provider to work correctly.
 */
const DisclaimerHandler: React.FC<Props> = ({ children }) => {
    useDisclaimerModal();
    return <>{children}</>;
};

export default DisclaimerHandler;
